import { defineMessages } from 'react-intl';

/**
 * Copy for the full-panel MCP policy-check alerts.
 *
 * There is deliberately no separate copy for a failed policy request and an
 * unexpected error: both mean "we could not load your permissions", which of
 * the two it was tells the user nothing they can act on, and the two are
 * therefore indistinguishable on screen — `somethingWentWrongTitle` +
 * `unexpectedBody` serve both (see McpPolicyAlerts.tsx). The
 * `policyAlert.policyFetch.*` and `policyAlert.unexpected.title` ids that used
 * to draw that distinction were removed with the collapse.
 */
export const mcpPolicyAlertMessages = defineMessages({
  somethingWentWrongTitle: {
    id: 'oauth.mcp.policyAlert.somethingWentWrong.title',
    defaultMessage: 'Something went wrong',
    description:
      'Error title shown whenever the permission check could not be completed, whether the request failed or errored unexpectedly',
  },
  workspaceAccessRevokedTitle: {
    id: 'oauth.mcp.policyAlert.workspaceAccessRevoked.title',
    defaultMessage: 'You no longer have access to this workspace',
    description:
      'Error title when the user has been removed from a selected Trello workspace',
  },
  workspaceAccessRevokedBody: {
    id: 'oauth.mcp.policyAlert.workspaceAccessRevoked.body',
    defaultMessage:
      'Your access to "{workspaceName}" has been removed. Select a different workspace or contact the workspace admin.',
    description:
      'Error body when the user has been removed from a selected Trello workspace; {workspaceName} is the workspace display name',
  },
  unexpectedBody: {
    id: 'oauth.mcp.policyAlert.unexpected.body',
    defaultMessage:
      'We’re having trouble showing permissions right now. You can try refreshing the page or <supportLink>contact support</supportLink>.',
    description:
      'Error body paired with the "Something went wrong" title for any permission check that could not be completed, with embedded link to the Atlassian support page',
  },
  missingRedirectTitle: {
    id: 'oauth.mcp.policyAlert.missingRedirect.title',
    defaultMessage: 'Redirect URL is missing',
    description: 'Error title when redirect URL is not provided by the app',
  },
  missingRedirectBody: {
    id: 'oauth.mcp.policyAlert.missingRedirect.body',
    defaultMessage:
      'This app must provide a redirect URL before you can continue. Cancel and contact the app developer.',
    description: 'Error body when redirect URL is not provided by the app',
  },
  domainNotAllowedTitle: {
    id: 'oauth.mcp.policyAlert.redirectNotAllowed.title',
    defaultMessage: 'Access to this domain is restricted',
    description: 'Error title when domain URL is not on the admin allowlist',
  },
  domainNotAllowedBodyLine1: {
    id: 'oauth.mcp.policyAlert.redirectNotAllowed.bodyLine1',
    defaultMessage:
      'Your admin has blocked this domain \"{redirectUrl}\" in your organization’s settings. To request access, contact your organization admin or <allowlistLink>find out about domain restrictions</allowlistLink>.',
    description:
      'Error body for redirect-not-allowed with embedded link to the admin allowlist documentation; {redirectUrl} is interpolated',
  },
});
